import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  OnDestroy,
  ChangeDetectionStrategy,
} from '@angular/core';

@Component({
  selector: 'app-ai-elearnio-loader',
  templateUrl: './ai-elearnio-loader.component.html',
  styleUrls: ['./ai-elearnio-loader.component.scss'],

  changeDetection: ChangeDetectionStrategy.Eager,

  standalone: false,
})
export class AiElearnioLoaderComponent implements OnInit, OnDestroy {
  @Output() cancelLoader = new EventEmitter<void>();

  messageKey = 'ai.aiSpinnerDialog.initial';
  private timerInterval: any;
  private startTime: number = Date.now();

  constructor() {}

  ngOnInit(): void {
    this.timerInterval = setInterval(() => {
      const elapsedSeconds = Math.floor((Date.now() - this.startTime) / 1000);

      if (elapsedSeconds < 10) {
        this.messageKey = 'ai.aiSpinnerDialog.initial';
      } else if (elapsedSeconds >= 10 && elapsedSeconds < 120) {
        this.messageKey = 'ai.aiSpinnerDialog.inProgress';
      } else {
        this.messageKey = 'ai.aiSpinnerDialog.longWait';
      }
    }, 1000);
  }

  onCancelClick(): void {
    this.cancelLoader.emit();
    clearInterval(this.timerInterval);
  }

  ngOnDestroy(): void {
    clearInterval(this.timerInterval);
  }
}
